import { useState } from "react";
// components
import { Button } from "@components/Button/Button";
import api from "@src/utils";
// packages
import { Group, PinInput } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@/src/app/hooks";
import { authenticate } from "@/src/features/userSlice";
import va from "@vercel/analytics";
import apiRoutes from "@/src/apiRoutes";
import { toast } from "sonner";

const TFALogin = () => {
  const { lastPath } = useAppSelector((state) => state.user);
  const navigate = useNavigate();
  const { state } = useLocation();
  const [code, setCode] = useState("");
  const dispatch = useAppDispatch();

  // function to confirm tfa code
  const confirm_tfa = async (e: React.FormEvent) => {
    e.preventDefault();
    const res = await api.post(apiRoutes.login2fa, {
      ...state,
      code: code,
    });
    return res.data;
  };

  const { mutate, isLoading } = useMutation({
    mutationKey: ["tfa_confirm"],
    mutationFn: confirm_tfa,
    onSuccess: (data) => {
      if (data.success) {
        if (data.token) {
          navigate("/auth/confirm_otp", { replace: true, state: data.token });
        } else {
          va.track("login");
          // toast.success("");
          navigate(lastPath ?? "/app/home");
          dispatch(authenticate(data.info));
        }
        //   if (data.account.kind === "trader") {
        //     dispatch(authenticate(data.account));
        //     toast.success(data?.info);
        //     if (data?.account?.banned) {
        //       navigate("/account/banned");
        //     } else if (data?.account?.suspended) {
        //       navigate("/account/suspended");
        //     } else {
        //       navigate(lastPath ?? "/app/home");
        //     }

        //     if (data?.account?.referred) {
        //       navigate("/app/settings/profile", { state: { resetPass: true } });
        //     }
        //   } else if (data.account.kind?.toLowerCase() === "moderator") {
        //     dispatch(authenticate(data.account));
        //     navigate("/trades");
        //   }
        // }
      } else {
        // notification.warning({
        //   message: "Invalid 2FA",
        //   description: "Please enter a valid 2FA",
        //   placement: "bottomRight",
        // });
        toast.error(data?.info);
      }
    },
  });

  return (
    <div>
      <h1 className="font-semibold text-2xl tracking-tight text-center ">
        Verify 2FA
      </h1>
      <p className="text-sm text-center text-gray-500 mt-4">
        Enter the 2FA verification code from your 2FA app
      </p>
      <form className="mt-5 grid gap-3">
        <Group position="center">
          <PinInput type={"number"} length={6} onChange={setCode} size={"lg"} />
        </Group>
        <div className="flex items-center justify-center mt-5">
          <Button
            onClick={mutate}
            loading={isLoading}
            type={"submit"}
            // title={"Submit"}
            variant={"primary"}
            className="w-full"
          >
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
};

export default TFALogin;
